import {ReactNode} from 'react';

type PersonHoverCardProps = {
  children: ReactNode;
  ldap: string;
  name: string;
  profilePhotoUrl?: string | null;
  role?: string | null;
};

export const PersonHoverCard = ({children}: PersonHoverCardProps) => {
  return <>{children}</>;
};

type TeamHoverCardProps = {
  children: ReactNode;
  slug: string;
  name: string;
  description?: string | null;
  profilePhotoUrl?: string | null;
  memberCount?: number;
  primaryContactName?: string | null;
};

export const TeamHoverCard = ({children}: TeamHoverCardProps) => {
  return <>{children}</>;
};
